import { ArtsApiRemoteService } from '../../Services/api/arts/arts-service'
import { IArtEntity, IArtsListResponse } from '../../Services/api/arts/arts.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListArtsUseCase
implements IFormUsecase<number, IArtsListResponse> {
  constructor (private readonly ArtsApi: ArtsApiRemoteService) {}
    

  public async handle (
    page: number
  ): Promise<Result<IArtsListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ArtsApi.list(page)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
